import { Amplify } from 'aws-amplify';

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: window.runtimeConfig.userPoolId,
      userPoolClientId: window.runtimeConfig.userPoolClientId,
      signUpVerificationMethod: 'code',
      loginWith: {
        oauth: {
          domain: window.runtimeConfig.cognitoDomain,
          scopes: [
            'openid',
            'email',
            'profile',
            'aws.cognito.signin.user.admin'
          ],
          redirectSignIn: [
            window.location.origin + '/callback',
            window.location.origin
          ],
          redirectSignOut: [
            window.location.origin + '/login',
            window.location.origin
          ],
          responseType: 'code'
        }
      }
    }
  },
  API: {
    GraphQL: {
      endpoint: window.runtimeConfig.graphqlEndpoint,
      region: window.runtimeConfig.region,
      defaultAuthMode: 'userPool'
    }
  }
};

console.log('Runtime config:', window.runtimeConfig);
console.log('Amplify config:', amplifyConfig);

Amplify.configure(amplifyConfig);

export { amplifyConfig };